import { bindReporteManualTourLink } from './reporteManualTour'

const isElementVisible = (selector) => {
    const element = document.querySelector(selector)
    return Boolean(element && element.offsetParent !== null)
}

const focusFormulaInput = () => {
    const editor = document.querySelector('#formula-input-group .formula-editor')
    editor?.focus()
}

const VARIAVEIS_PANEL_SELECTOR = '#container-campo-customizado.campo-customizado-visible'
const FORMULA_MODAL_SELECTOR = '#modal-formula .modal-content'
const REFERENCIA_MODAL_SELECTOR = '[data-tour="param-referencia-modal"] .modal-content'

const openVariaveisPanel = (tourManager) => {
    focusFormulaInput()
    return tourManager.waitForElement(VARIAVEIS_PANEL_SELECTOR)
}

const isFormulaModalOpen = () => Boolean(document.querySelector(FORMULA_MODAL_SELECTOR))

const openFormulaModal = (tourManager) => {
    if (isFormulaModalOpen()) return Promise.resolve()

    document.querySelector('[data-tour="param-btn-formulas"]')?.click()
    return tourManager.waitForElement(FORMULA_MODAL_SELECTOR)
}

const closeFormulaModal = () => {
    if (!isFormulaModalOpen()) return

    const closeBtn = document.querySelector('#modal-formula .close')
    closeBtn?.click()
}

const clickTab = (selector) => {
    const tabElement = document.querySelector(selector)

    if (tabElement && !tabElement.classList.contains('react-tabs__tab--selected')) {
        tabElement.click()
    }
}

const bindMinimizeOnClick = (element, handler) => {
    if (!element || element._hdvTourMinimizeClick) return

    element.addEventListener('click', handler)
    element._hdvTourMinimizeClick = handler
}

const unbindMinimizeOnClick = (element) => {
    if (!element?._hdvTourMinimizeClick) return

    element.removeEventListener('click', element._hdvTourMinimizeClick)
    delete element._hdvTourMinimizeClick
}

const minimizeIfModalOpens = (tourManager, { timeout = 4000, interval = 250 } = {}) => {
    const start = Date.now()

    const timer = setInterval(() => {
        const modalAberto = document.querySelector('.modal.show, .modal[style*="display: block"]')

        if (modalAberto && tourManager.isActive()) {
            clearInterval(timer)
            tourManager.minimize()
            return
        }

        if (Date.now() - start > timeout || !tourManager.isActive()) {
            clearInterval(timer)
        }
    }, interval)
}

const getTipoDado = () => document.querySelector('#tipo_dado_saida')?.value

const abrirModalReferencia = (tourManager) => {
    if (document.querySelector(REFERENCIA_MODAL_SELECTOR)) return Promise.resolve()

    clickTab('[data-tour="param-tab-referencias"]')

    return tourManager.waitForElement('[data-tour="param-nova-referencia"]').then((button) => {
        button.click()
        return tourManager.waitForElement(REFERENCIA_MODAL_SELECTOR)
    })
}

const posicionarPopoverAbaixoDoModal = (modalSelector) => {
    const apply = () => {
        const popover = document.querySelector('.driver-popover.hdv-tour-popover-canto-inferior')
        const modal = document.querySelector(modalSelector)
        if (!popover || !modal) return

        const gap = 10
        const edge = 12
        const modalRect = modal.getBoundingClientRect()
        const popWidth = popover.offsetWidth || 360
        const popHeight = popover.offsetHeight || 220

        const left = Math.max(
            edge,
            Math.min(
                modalRect.left + (modalRect.width - popWidth) / 2,
                window.innerWidth - popWidth - edge
            )
        )
        const top = Math.max(
            edge,
            Math.min(modalRect.bottom + gap, window.innerHeight - popHeight - edge)
        )

        popover.style.setProperty('--hdv-popover-left', `${Math.round(left)}px`)
        popover.style.setProperty('--hdv-popover-top', `${Math.round(top)}px`)
        popover.style.left = ''
        popover.style.right = 'auto'
        popover.style.top = ''
        popover.style.bottom = 'auto'
        popover.style.transform = 'none'
        popover.style.margin = '0'
    }

    apply()
    requestAnimationFrame(apply)
    setTimeout(apply, 80)
    setTimeout(apply, 350)
    setTimeout(apply, 480)
}

const mostrarAviso = (message, options = {}) => {
    document.dispatchEvent(new CustomEvent('showAviso', {
        detail: {
            message,
            callback: options.callback ?? null,
            callbackClose: options.callbackClose ?? null,
            callbackLabelClose: options.callbackLabelClose ?? 'Fechar',
            callbackLabel: options.callbackLabel ?? 'Continuar',
        },
    }))
}

const AVISO_FINALIZAR_CADASTRO =
    'Finalize o cadastro do parâmetro, clique em <b>Testar fórmula</b> para liberar o botão <b>Salvar</b> e, após salvar, acesse a tela de <b>Monitorado</b> para vinculá-lo.'

const AVISO_SALVAR_E_ENCAMINHAR =
    'O parâmetro que está sendo cadastrado será <b>salvo</b> e você será encaminhado à tela de <b>Monitorado</b>.'

const aguardarAvisoDeSucesso = (tourManager) =>
    tourManager.waitForElement(() => {
        const body = document.querySelector('.modal.show .modal-body')

        if (body && /sucesso/i.test(body.textContent || '')) return body

        return null
    }, 8000)

const salvarEIrParaMonitorado = (tourManager) => {
    const saveButton = document.querySelector('[data-tour="param-salvar"]')

    saveButton?.click()
    tourManager.clearSavedProgress('parametrizacao')

    aguardarAvisoDeSucesso(tourManager)
        .then(() => {
            document.querySelector('.modal.show .modal-footer .hdv-btn-default')?.click()

            setTimeout(() => {
                tourManager.history?.push('/monitorado')
                tourManager.waitForElement('[data-tour="help-monitorado-grid"]')
                    .then(() => tourManager.start('novo-monitorado', { resumeIndex: 0 }))
                    .catch(() => {})
            }, 150)
        })
        .catch(() => {
        })
}

const vincularAoMonitorado = (tourManager) => {
    const saveButton = document.querySelector('[data-tour="param-salvar"]')
    const descricao = document.querySelector('[data-tour="param-descricao"] input')?.value?.trim()

    if (!saveButton || saveButton.disabled || !descricao) {
        tourManager.finish('parametrizacao')
        mostrarAviso(AVISO_FINALIZAR_CADASTRO)
        return
    }

    tourManager.minimize()

    mostrarAviso(AVISO_SALVAR_E_ENCAMINHAR, {
        callback: () => salvarEIrParaMonitorado(tourManager),
        callbackClose: () => tourManager.clearSavedProgress('parametrizacao'),
        callbackLabelClose: 'Cancelar',
    })
}

const bindVincularMonitoradoLink = (tourManager) => {
    setTimeout(() => {
        const link = document.querySelector('.driver-popover-description [data-hdv-vincular-monitorado]')

        if (!link || link._hdvVincularMonitoradoBound) return

        link._hdvVincularMonitoradoBound = true
        link.addEventListener('click', (event) => {
            event.preventDefault()
            event.stopPropagation()
            vincularAoMonitorado(tourManager)
        })
    }, 0)
}

const isVirtualParametrizacao = () =>
    document.querySelector('[data-tour="parametrizacao-root"]')?.getAttribute('data-is-virtual') === 'true'

const buildParametrizacaoTourSteps = (tourManager) => {
    const temFormula = isElementVisible('[data-tour="param-formula"]')

    const steps = [
        {
            element: '[data-tour="param-descricao"]',
            popover: {
                title: 'Descrição',
                description: "Dê uma descrição, ou nome de sua escolha para esse parâmetro. É esse nome que vai aparecer nos gráficos e telas do sistema.",
                side: 'bottom',
                align: 'start',
            },
        },
        {
            element: '[data-tour="param-identificador"]',
            popover: {
                title: 'Identificador',
                description: 'Um código único para salvar esse parâmetro. Não pode repetir o mesmo identificador em outro parâmetro deste equipamento.<br>Esse campo será preenchido automaticamente ao inserir a descrição.',
                side: 'bottom',
                align: 'start',
            },
        },
    ]

    if (temFormula) {
        steps.push(
            {
                element: '[data-tour="param-formula"]',
                popover: {
                    title: 'Fórmula',
                    description: 'Aqui você define como o parâmetro vai calcular seu valor. Pode ser uma conta simples (ex: [ct_pulso.1] * 10), ou até mesmo fórmulas matemáticas complexas de sua escolha. Clique em <strong>Próximo</strong> para ver as opções disponíveis.',
                    side: 'bottom',
                    align: 'start',
                    onNextClick: () => {
                        openVariaveisPanel(tourManager)
                            .then(() => tourManager.moveNext())
                            .catch(() => tourManager.moveNext())
                    },
                },
            },
            {
                element: '#container-campo-customizado',
                ensureReady: () => openVariaveisPanel(tourManager),
                popover: {
                    title: 'Variáveis disponíveis',
                    description: 'As badges <span class="formula-badge formula-badge-variavel">verdes</span> são os dados que o equipamento envia (ex: entrada analógica). As badges <span class="formula-badge bg-primary">azuis</span> são parâmetros que você já cadastrou antes. Clique em uma <span class="formula-badge formula-badge-variavel">Badge</span> para inserir no campo de fórmula.',
                    side: 'left',
                    align: 'start',
                },
            },
            {
                element: '[data-tour="param-btn-formulas"]',
                popover: {
                    title: 'Fórmulas prontas',
                    description: 'Caso não possuir uma formula, este botão abre uma lista de modelos prontos. Clique em <strong>Próximo</strong> para ver a lista.',
                    side: 'bottom',
                    align: 'end',
                    onPrevClick: () => {
                        openVariaveisPanel(tourManager)
                            .then(() => tourManager.movePrevious())
                            .catch(() => tourManager.movePrevious())
                    },
                    onNextClick: () => {
                        unbindMinimizeOnClick(document.querySelector('[data-tour="param-btn-formulas"]'))
                        openFormulaModal(tourManager)
                            .then(() => tourManager.moveNext())
                            .catch(() => {})
                    },
                },
                onHighlighted: (element) => {
                    bindMinimizeOnClick(element, () => tourManager.minimize())
                },
                onDeselected: (element) => {
                    unbindMinimizeOnClick(element)
                },
            },
            {
                element: FORMULA_MODAL_SELECTOR,
                ensureReady: () => openFormulaModal(tourManager),
                popover: {
                    title: 'Escolher fórmula pronta',
                    description: 'Escolha uma das fórmulas da lista e clique no botão <strong>+</strong> para adicioná-la ao campo de fórmula.',
                    popoverClass: 'hdv-tour-popover hdv-tour-popover-canto-inferior',
                    side: 'bottom',
                    align: 'center',
                    onPrevClick: () => {
                        closeFormulaModal()
                        setTimeout(() => tourManager.movePrevious(), 300)
                    },
                    onNextClick: () => {
                        closeFormulaModal()
                        setTimeout(() => tourManager.moveNext(), 300)
                    },
                },
                onHighlighted: () => {
                    posicionarPopoverAbaixoDoModal(FORMULA_MODAL_SELECTOR)
                },
            },
            {
                element: '#formula-input-group',
                popover: {
                    title: 'Badges na fórmula',
                    description: 'Ao adicionar uma fórmula pronta, os itens destacados (badges) aparecem aqui no campo. Clique na badge que deseja trocar para selecioná-la.',
                    side: 'bottom',
                    align: 'start',
                    onPrevClick: () => {
                        openFormulaModal(tourManager)
                            .then(() => tourManager.movePrevious())
                            .catch(() => {})
                    },
                    onNextClick: () => {
                        openVariaveisPanel(tourManager)
                            .then(() => tourManager.moveNext())
                            .catch(() => tourManager.moveNext())
                    },
                },
            },
            {
                element: '#container-campo-customizado',
                ensureReady: () => openVariaveisPanel(tourManager),
                popover: {
                    title: 'Substituir pelas variáveis do equipamento',
                    description: 'Com a badge do campo selecionada, clique em uma das badges deste painel para substituí-la. Assim você monta a fórmula com base nos dados reais enviados pelo seu equipamento.',
                    side: 'left',
                    align: 'start',
                },
            }
        )
    }

    const idxTipoDado = steps.length
    let tipoDadoInicial = null

    steps.push({
        element: '[data-tour="param-tipo-dado"]',
        popover: {
            title: 'Tipo de dado',
            description: 'Escolha o tipo de resultado que essa fórmula vai gerar: número decimal, número inteiro, verdadeiro/falso ou texto.',
            side: 'bottom',
            align: 'start',
            onNextClick: () => {
                if (getTipoDado() !== tipoDadoInicial) {
                    const rebuilt = buildParametrizacaoTourSteps(tourManager)
                    tourManager.setSteps(rebuilt, idxTipoDado + 1)
                    return
                }

                tourManager.moveNext()
            },
        },
        onHighlighted: () => {
            tipoDadoInicial = getTipoDado()
        },
    })

    if (isElementVisible('[data-tour="param-tipo-grafico"]')) {
        steps.push({
            element: '[data-tour="param-tipo-grafico"]',
            popover: {
                title: 'Tipo de gráfico',
                description: 'Escolha como esse parâmetro vai aparecer nos gráficos: Linha (recomendado para valores que variam, como tensão, nível ou temperatura) ou Barra (recomendado para volumes acumulados, como hidrômetro ou horímetro).',
                side: 'bottom',
                align: 'start',
            },
        })
    }

    if (isElementVisible('[data-tour="param-unidade"]')) {
        steps.push({
            element: '[data-tour="param-unidade"]',
            popover: {
                title: 'Unidade de medida',
                description: 'Digite a unidade desse valor, como m³, °C, metros ou horas.',
                side: 'bottom',
                align: 'start',
            },
        })
    }

    if (isElementVisible('[data-tour="param-decimal"]')) {
        steps.push({
            element: '[data-tour="param-decimal"]',
            popover: {
                title: 'Casas decimais',
                description: 'Escolha quantas casas decimais devem aparecer no valor exibido.',
                side: 'bottom',
                align: 'start',
            },
        })
    }

    if (isElementVisible('[data-tour="param-operador"]')) {
        steps.push({
            element: '[data-tour="param-operador"]',
            popover: {
                title: 'Operador especial',
                description: 'Define um comportamento extra para o cálculo: Padrão (executa a fórmula normalmente), Incremental (soma os valores ao longo do tempo) ou Volume do dia/semana/mês (soma os valores, mas reinicia a contagem automaticamente no início de cada período).',
                side: 'bottom',
                align: 'start',
            },
        })
    }

    if (isElementVisible('[data-tour="param-mascara"]')) {
        steps.push({
            element: '[data-tour="param-mascara"]',
            popover: {
                title: 'Máscara',
                description: 'Use quando o valor representa horas em número bruto. A máscara converte o número para o formato hh:mm:ss.',
                side: 'bottom',
                align: 'start',
            },
        })
    }

    const bindMinimizeOnIconClick = (element) => {
        element?.querySelectorAll?.('.escolha-icones').forEach((icone) => {
            bindMinimizeOnClick(icone, () => tourManager.minimize())
        })
    }

    const unbindMinimizeOnIconClick = (element) => {
        element?.querySelectorAll?.('.escolha-icones').forEach((icone) => {
            unbindMinimizeOnClick(icone)
        })
    }

    if (isElementVisible('[data-tour="param-icone"]')) {
        steps.push({
            element: '[data-tour="param-icone"]',
            popover: {
                title: 'Ícone',
                description: 'Escolha um ícone para representar esse parâmetro nas telas do sistema.',
                side: 'top',
                align: 'start',
            },
            onHighlighted: bindMinimizeOnIconClick,
            onDeselected: unbindMinimizeOnIconClick,
        })
    } else if (isElementVisible('[data-tour="param-icone-booleano"]')) {
        steps.push({
            element: '[data-tour="param-icone-booleano"]',
            popover: {
                title: 'Ícones',
                description: 'Escolha os ícones que representam esse parâmetro nas telas do sistema: um para o estado verdadeiro e outro para o falso.',
                side: 'top',
                align: 'start',
            },
            onHighlighted: bindMinimizeOnIconClick,
            onDeselected: unbindMinimizeOnIconClick,
        })
    }

    if (temFormula) {
        steps.push({
            element: '[data-tour="param-testar-formula"]',
            popover: {
                title: 'Testar fórmula',
                description: 'Clique aqui para ver o resultado da fórmula que você escreveu. Se houver algum erro, o sistema vai avisar que a fórmula é inválida.',
                side: 'top',
                align: 'start',
            },
            onHighlighted: (element) => {
                bindMinimizeOnClick(element, () => minimizeIfModalOpens(tourManager))
            },
            onDeselected: (element) => {
                unbindMinimizeOnClick(element)
            },
        })
    }

    steps.push(
        {
            element: '[data-tour="param-tab-referencias"]',
            popover: {
                title: 'Referências',
                description: 'Nesta aba você adiciona linhas de referência ao gráfico deste parâmetro: valores fixos que servem de comparação, como um limite máximo de consumo. Clique em <strong>Próximo</strong> para abri-la.',
                side: 'bottom',
                align: 'start',
                onNextClick: () => {
                    clickTab('[data-tour="param-tab-referencias"]')
                    setTimeout(() => tourManager.moveNext(), 200)
                },
            },
        },
        {
            element: '[data-tour="param-nova-referencia"]',
            popover: {
                title: 'Nova referência',
                description: 'As referências criadas ficam listadas aqui na aba. Clique em <strong>Próximo</strong> para abrir o cadastro de uma nova referência.',
                side: 'bottom',
                align: 'start',
                onPrevClick: () => {
                    clickTab('[data-tour="param-tab-parametrizar"]')
                    setTimeout(() => tourManager.movePrevious(), 200)
                },
                onNextClick: () => {
                    document.querySelector('[data-tour="param-nova-referencia"]')?.click()
                    tourManager.waitForElement(REFERENCIA_MODAL_SELECTOR)
                        .then(() => tourManager.moveNext())
                        .catch(() => {})
                },
            },
        },
        {
            element: REFERENCIA_MODAL_SELECTOR,
            ensureReady: () => abrirModalReferencia(tourManager),
            popover: {
                title: 'Configurar referência',
                description: 'É aqui que você configura a referência: dê uma descrição, escolha a cor da linha, a condição (maior ou menor) e o valor. Ao adicionar, a linha aparece no gráfico do parâmetro como comparação visual. Por exemplo, para marcar um limite máximo de consumo que não deve ser ultrapassado.',
                side: 'bottom',
                align: 'center',
                onPrevClick: () => {
                    document.querySelector(`${REFERENCIA_MODAL_SELECTOR} .hdv-btn-yellow`)?.click()
                    setTimeout(() => tourManager.movePrevious(), 300)
                },
                onNextClick: () => {
                    document.querySelector(`${REFERENCIA_MODAL_SELECTOR} .hdv-btn-yellow`)?.click()
                    clickTab('[data-tour="param-tab-parametrizar"]')
                    setTimeout(() => tourManager.moveNext(), 300)
                },
            },
        },
        {
            element: '[data-tour="param-salvar"]',
            ensureReady: () => {
                clickTab('[data-tour="param-tab-parametrizar"]')
                return Promise.resolve()
            },
            popover: {
                title: 'Salvar',
                description: 'Este botão salva o parâmetro. Ele é liberado após clicar em <strong>Testar fórmula</strong> com uma fórmula válida.',
                side: 'top',
                align: 'start',
                onPrevClick: () => {
                    abrirModalReferencia(tourManager)
                        .then(() => tourManager.movePrevious())
                        .catch(() => {})
                },
            },
        },
        {
            popover: {
                title: 'Pronto!',
                description: 'Preencha todos os campos conforme este guia e salve o parâmetro. Ao finalizar, é recomendado <a href="#" class="hdv-tour-start-link" data-hdv-vincular-monitorado>vincular os parâmetros ao Monitorado</a> para acompanhá-los nas telas de monitoramento.',
                onPrevClick: () => tourManager.movePrevious(),
            },
            onHighlighted: () => {
                if (isVirtualParametrizacao()) {
                    const popoverDescription = document.querySelector('.driver-popover-description')

                    if (popoverDescription) {
                        popoverDescription.innerHTML =
                            'Preencha os campos e salve o parâmetro. Em equipamentos virtuais, os dados chegam pelo <strong>Reporte Manual</strong> — é lá que você envia pacotes para alimentar parâmetros e gráficos.<br><br><a href="#" class="hdv-tour-start-link" data-hdv-start-tour="reporte-manual">Clique aqui</a> para iniciar o guia de Reporte Manual.<br><br>Depois, é recomendado <a href="#" class="hdv-tour-start-link" data-hdv-vincular-monitorado>vincular os parâmetros ao Monitorado</a>.'
                    }

                    bindReporteManualTourLink(tourManager, 'parametrizacao')
                }

                bindVincularMonitoradoLink(tourManager)
            },
        }
    )

    return steps
}

export default buildParametrizacaoTourSteps
